module.exports = __webpack_public_path__ + "img/icon-onboarding.5306de39.svg";